import { Box } from '@mui/material';
import classes from './ProgressiveBars.module.css';

const ProgressiveBars = () => {
  return (
    <Box className={classes.loader}>
      <Box className={`${classes.bar} ${classes.bar1}`}></Box>
      <Box className={`${classes.bar} ${classes.bar2}`}></Box>
      <Box className={`${classes.bar} ${classes.bar3}`}></Box>
      <Box className={`${classes.bar} ${classes.bar4}`}></Box>
      <Box className={`${classes.bar} ${classes.bar5}`}></Box>
    </Box>
  );
};

export default ProgressiveBars;
